import facepaint from 'facepaint'
import breakPoints from './breakPoints'

const breakpoints = [
  breakPoints.sm,
  breakPoints.md,
  breakPoints.lg,
  breakPoints.xl,
]

const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

export default mq
